import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Theme, Card, Flex, Text, Link, Button } from "@radix-ui/themes";
import { FaLinkedin, FaGithub, FaTwitter, FaGlobe } from "react-icons/fa";
import Cal from "@calcom/embed-react";

function MinimalDark({ user }) {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <Theme appearance="dark" accentColor="gray">
      <Helmet>
        <title>{user?.name} | Profiles</title>
        <meta
          name="description"
          content={`${user?.name}'s profile on Profiler. View links, bio, and schedule meetings.`}
        />
      </Helmet>
      <div style={{ background: "#0e0e0e", minHeight: "100vh" }}>
        {!showCalendar ? (
          <Flex
            align="center"
            justify="center"
            style={{
              height: "100vh",
              padding: "2rem",
              display: "flex",
            }}
          >
            <Card
              size="4"
              style={{
                maxWidth: "480px",
                width: "100%",
                borderRadius: "16px",
                background: "#111",
                border: "1px solid #2e2e2e",
                boxShadow: "0 8px 32px rgba(255, 255, 255, 0.05)",
                padding: "2rem",
                color: "#fff",
              }}
            >
              <Text size="5" weight="bold" style={{ color: "#e0e0e0" }}>
                {user.name} &nbsp;
              </Text>
              <Text color="gray" style={{ marginBottom: "1rem" }}>
                @{user.username}
              </Text>{" "}
              <br />
              <Text style={{ lineHeight: "1.6", color: "#ccc" }}>
                {user.description}
              </Text>
              <hr style={{ border: "1px solid #333", margin: "1.5rem 0" }} />
              <Flex gap="4" mt="1" align="center" wrap="wrap">
                {user.socialLinks?.linkedin && (
                  <Link
                    href={user.socialLinks.linkedin}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#aaa",
                      gap: "6px",
                    }}
                  >
                    <FaLinkedin style={{ opacity: 0.8 }} /> LinkedIn
                  </Link>
                )}
                {user.socialLinks?.github && (
                  <Link
                    href={user.socialLinks.github}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#aaa",
                      gap: "6px",
                    }}
                  >
                    <FaGithub style={{ opacity: 0.8 }} /> GitHub
                  </Link>
                )}
                {user.socialLinks?.twitter && (
                  <Link
                    href={user.socialLinks.twitter}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#aaa",
                      gap: "6px",
                    }}
                  >
                    <FaTwitter style={{ opacity: 0.8 }} /> Twitter
                  </Link>
                )}
                {user.socialLinks?.website && (
                  <Link
                    href={user.socialLinks.website}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#aaa",
                      gap: "6px",
                    }}
                  >
                    <FaGlobe style={{ opacity: 0.8 }} /> Website
                  </Link>
                )}
              </Flex>
              {user.calcomUsername && (
                <Flex justify="center">
                  <Button
                    mt="4"
                    variant="solid"
                    color="gray"
                    onClick={() => setShowCalendar(true)}
                  >
                    Schedule Meeting
                  </Button>
                </Flex>
              )}
            </Card>
          </Flex>
        ) : (
          <Flex
            justify="center"
            style={{ animation: "fadeIn 400ms ease-in-out" }}
          >
            <div
              style={{ width: "100%", overflow: "hidden", marginTop: "4rem" }}
            >
              <Cal calLink={`${user.calcomUsername}/15min`} />
            </div>
          </Flex>
        )}

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </div>
    </Theme>
  );
}

export default MinimalDark;
